 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
import createProxyRecord from '../../utils/relay/createProxyRecord'

const handleEditTask = (payload, store) => {
  const taskId = _optionalChain([payload, 'access', _ => _.getLinkedRecord, 'call', _2 => _2('task'), 'optionalAccess', _3 => _3.getValue, 'call', _4 => _4('id')]) 
  const task = store.get(taskId)
  if (!task) return
  const editor = payload.getLinkedRecord('editor')
  const userId = editor.getValue('id')
  const isEditing = payload.getValue('isEditing')

  const taskEditors = task.getLinkedRecords('editors') || []
  const newTaskEditors = [] 
  if (isEditing) {
    // handle multiple socket connections
    for (let ii = 0; ii < taskEditors.length; ii++) {
      const taskEditor = taskEditors[ii]
      if (taskEditor.getValue('userId') === userId) return
      newTaskEditors.push(taskEditor)
    }
    const preferredName = editor.getValue('preferredName')
    const newTaskEditor = createProxyRecord(store, 'TaskEditorDetails', {
      userId,
      preferredName
    })
    newTaskEditors.push(newTaskEditor)
  } else {
    for (let ii = 0; ii < taskEditors.length; ii++) {
      const taskEditor = taskEditors[ii]
      if (taskEditor && taskEditor.getValue('userId') !== userId) {
        newTaskEditors.push(taskEditor)
      }
    }
  }
  task.setLinkedRecords(newTaskEditors, 'editors')
}

export default handleEditTask
